'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactSlick = require('react-slick');

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _FeaturedReviews = require('./FeaturedReviews.scss');

var _FeaturedReviews2 = _interopRequireDefault(_FeaturedReviews);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  FeaturedReviews: {
    displayName: 'FeaturedReviews'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Pachantiew/FeaturedReviews.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import Link from 'components/Link/Link';

// import LocalExpertItem from './LocalExpertItem';
// import ReviewItem from './ReviewItem';

var FeaturedReviews = _wrapComponent('FeaturedReviews')((_dec = (0, _reactCssModules2.default)(_FeaturedReviews2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FeaturedReviews, _Component);

  function FeaturedReviews() {
    (0, _classCallCheck3.default)(this, FeaturedReviews);
    return (0, _possibleConstructorReturn3.default)(this, (FeaturedReviews.__proto__ || (0, _getPrototypeOf2.default)(FeaturedReviews)).apply(this, arguments));
  }

  (0, _createClass3.default)(FeaturedReviews, [{
    key: 'render',
    value: function render() {
      var reviews = {};
      for (var i = 1; i <= 34; i++) {
        reviews['img-' + i] = require('./' + i + '.jpg');
      }
      return _react3.default.createElement(
        'div',
        { styleName: 'container' },
        _react3.default.createElement(
          'div',
          { styleName: 'inner' },
          _react3.default.createElement(
            'div',
            { styleName: 'reviews-wrapper' },
            _react3.default.createElement(
              'div',
              { styleName: 'reviews-card-wrapper' },
              _react3.default.createElement(
                _reactSlick2.default,
                { responsive: [{ breakpoint: 700, settings: { slidesToShow: 1, slidesToScroll: 1, dots: false } }], speed: 700, slidesToScroll: 2, slidesToShow: 2, swipe: true, dotsClass: 'featured-slick-dots', className: 'pachantiew-review-slider' },
                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34].map(function (review) {
                  return _react3.default.createElement(
                    'div',
                    { key: review, styleName: 'review-item-container' },
                    _react3.default.createElement(
                      'a',
                      null,
                      _react3.default.createElement('div', { styleName: 'review-item', style: { backgroundImage: 'url(' + reviews['img-' + review] + ')' } })
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return FeaturedReviews;
}(_react2.Component), _class2.propTypes = {
  reviews: _react2.PropTypes.array
}, _class2.defaultProps = {
  reviews: []
}, _temp)) || _class));

exports.default = FeaturedReviews;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/FeaturedReviews.js
// module id = 670
// module chunks = 47